import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Anchor from '../../../UniformComponents/Anchor'
import DropdownButton from '../../../UniformComponents/DropdownButton'
import SurveyStore from '../SurveyStore'
import BranchingBanner from './BranchingBanner'
import Badge from '../../../UniformComponents/Badge'

const SCROLL_THRESHOLD = 20
@observer
export default class NewNavigationTabs extends Component {
    constructor(props) {
        super(props)
        const { store, showCertification } = this.props
        this.surveyStore = new SurveyStore(store, showCertification)
        this.state = {
            isVisible: true,
        }
        this.scrollStart = 0
        this.scrollFinish = 0
        this.isScrollingDown = false
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        this.scrollFinish = window.scrollY
        this.scrollStart = window.scrollY
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {
        const { store } = this.props
        const { survey } = store
        const { showBranchBanner } = survey
        const scorllThreshold = showBranchBanner ? SCROLL_THRESHOLD + 60 : SCROLL_THRESHOLD
        const currentYPos = window.scrollY
        const { isVisible } = this.state
        if (currentYPos < scorllThreshold && !isVisible) this.setState({ isVisible: true })
        const isCurrentlyScrollingDown = currentYPos > this.scrollFinish

        const hasDirectionChanged = isCurrentlyScrollingDown !== this.isScrollingDown
        if (hasDirectionChanged) {
            this.scrollStart = currentYPos
            this.isScrollingDown = isCurrentlyScrollingDown
        }

        const scrollDistance = Math.abs(currentYPos - this.scrollStart)
        if (scrollDistance > scorllThreshold) {
            const shouldBeVisible = !this.isScrollingDown
            if (shouldBeVisible !== isVisible) {
                this.setState({ isVisible: shouldBeVisible })
                this.scrollStartY = currentYPos
            }
        }
        this.scrollFinish = currentYPos
    }

    refresh = () => {
        const { activeTab, store } = this.props
        if (activeTab === 'report') {
            store.reloadPage = true
        }
    }

    getPreviewOptions = () => {
        const { store } = this.props
        const { survey } = store
        return [{
            type: 'button',
            cssClass: 'dropdown-button-item',
            label: survey.isMaxbi() ? i18n.t('maxbi_preview') : i18n.t('s_preview'),
            icon: 'fas fa-eye',
            onClick: () => window.open(survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale), '_blank'),
        }, {
            type: 'button',
            cssClass: 'dropdown-button-item',
            label: i18n.t('s_print_2'),
            icon: 'fal fa-print',
            onClick: () => window.open(`/survey/${survey.id}/print`, '_blank'),
        }]
    }

    render() {
        const { store, activeTab } = this.props
        const { survey } = store
        const { showBranchBanner, metadata } = survey
        const { isParent } = metadata
        const { isVisible } = this.state
        const navigationTabs = this.surveyStore.getNavigationTabs(activeTab)

        return (
            <>
                <div
                    id="surveyTabsMenuContainer"
                    className={`${isVisible ? '' : 'hide-tabs'} ${showBranchBanner ? 'branching' : ''}`}
                >
                    {showBranchBanner ? <BranchingBanner store={store} forceClose={!isVisible} /> : null}
                    <nav id="surveyTabsMenu">
                        <ul>
                            <div className="left-menu-container">
                                {
                                    navigationTabs.filter((navTab) => navTab.visible).map((tab) => (
                                        <li className={`tabItem ${tab.style}`}>
                                            <Anchor href={tab.link} onClick={tab.name === 'Reports' ? this.refresh : null}>
                                                <i className={tab.icon} />
                                                {' '}
                                                <h4>{tab.name}</h4>
                                            </Anchor>
                                        </li>
                                    ))
                                }
                            </div>
                            {this.surveyStore.showSettingsAndPreview() && !survey.closed && (
                                <DropdownButton
                                    label={i18n.t('s_tab_preview_v2')}
                                    options={this.getPreviewOptions()}
                                    hasChevronIcon
                                    usePortal
                                    forceClose={!isVisible}
                                />
                            )}
                        </ul>
                    </nav>
                </div>
            </>
        )
    }
}
